// extracted by mini-css-extract-plugin
export default {"h1Header":"Header_h1Header__c73Ic"};